/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StagingAction } from './StagingAction';
import {
    StagingActionFromJSON,
    StagingActionFromJSONTyped,
    StagingActionToJSON,
    StagingActionToJSONTyped,
} from './StagingAction';

/**
 * 
 * @export
 * @interface ResolveStagingRequest
 */
export interface ResolveStagingRequest {
    /**
     * 
     * @type {StagingAction}
     * @memberof ResolveStagingRequest
     */
    action?: StagingAction;
}



/**
 * Check if a given object implements the ResolveStagingRequest interface.
 */
export function instanceOfResolveStagingRequest(value: object): value is ResolveStagingRequest {
    return true;
}

export function ResolveStagingRequestFromJSON(json: any): ResolveStagingRequest {
    return ResolveStagingRequestFromJSONTyped(json, false);
}

export function ResolveStagingRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResolveStagingRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'action': json['action'] == null ? undefined : StagingActionFromJSON(json['action']),
    };
}

export function ResolveStagingRequestToJSON(json: any): ResolveStagingRequest {
    return ResolveStagingRequestToJSONTyped(json, false);
}

export function ResolveStagingRequestToJSONTyped(value?: ResolveStagingRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'action': StagingActionToJSON(value['action']),
    };
}

